import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

const handleSiteHeader = () => {

    const siteHeader = document.querySelector('.c-site-header');
    if(!siteHeader) return;

    const logo = siteHeader.querySelector('.c-site-header__logo');
    const button = siteHeader.querySelector('.c-site-header__button');
    const arr = [logo, button];

    const handleShow = () => {
        arr.forEach((el) => {
            el.setAttribute('aria-hidden', false);
        });
    }

    const handleHide = () => {
        arr.forEach((el) => {
            el.setAttribute('aria-hidden', true);
        });
    }

    window.addEventListener('scroll', () => {
        window.pageYOffset > 25 ? handleHide() : handleShow();
    });

    document.querySelectorAll('[data-site-header="dark"').forEach(section => {
        ScrollTrigger.create({
            trigger: section,
            start: `top top+=80`,
            end: `bottom top+=80`,
            toggleClass: {
                targets: '.c-site-header',
                className: 'c-site-header--dark'
            }
        });
    });

}

export { handleSiteHeader }